<template>
  <Loader :loading="httpSend">
    <div class="row">
      <div class="col-md-12">
        <b-form ref="formEnd">
          <div class="row">
            <div class="col-md-3">
              <b-form-group label="Tipo" label-for="tab_codigo">
                <select id="tab_codigo" v-model="endereco.ted_tipo" class="custom-select"
                        :class="{ 'is-invalid': tipoEndExiste || $v.endereco.ted_tipo.$error }"
                        type="text">
                  <option value=""></option>
                  <option v-for="e in endereco_tipo" v-bind:value="e"
                          v-bind:key="e.tab_codigo">
                    {{ e.tab_nome }}
                  </option>
                </select>
                <div v-if="$v.endereco.ted_tipo.$error" class="invalid-feedback">
                  Informe o tipo
                </div>
                <div v-if="tipoEndExiste" class="invalid-feedback">
                  Tipo já informado
                </div>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group
                  id="cep-group"
                  label="CEP"
                  label-for="cep-reply">
                <input
                    id="cep-reply"
                    ref="ted_cep"
                    v-model="endereco.ted_cep"
                    v-on:focusout="locCEP(endereco.ted_cep)"
                    autocomplete="no"
                    v-mask="'##.###-###'"
                    type="text"
                    maxlength="20"
                    class="form-control"
                    placeholder=" "
                    :class="{'is-invalid': errorCep || (submitted && $v.endereco.ted_cep.$error)}">
                <div v-show="$v.endereco.ted_cep.$error" class="invalid-feedback">
                  Informe um CEP
                </div>
                <div v-show="errorCep" class="invalid-feedback">
                  CEP não encontrado
                </div>
              </b-form-group>
            </div>
            <div class="col-md-6">
              <b-form-group
                  id="cidade-group"
                  label="Cidade - UF"
                  label-for="cidade">
                <h5 v-if="endereco.mun_nome" class="mb-3 mt-3">{{ endereco.mun_nome }} -
                  {{ endereco.mun_uf }}</h5>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <b-form-group
                  id="quadra-group"
                  label="Endereço/Quadra"
                  label-for="quadra">
                <input
                    id="quadra"
                    ref="ted_logradouro"
                    v-model="endereco.ted_logradouro"
                    type="text"
                    maxlength="200"
                    class="form-control"
                    placeholder=" "
                    :class="{'is-invalid': submitted && $v.endereco.ted_logradouro.$error,}">
                <div v-show="$v.endereco.ted_logradouro.$error" class="invalid-feedback">
                  Informe seu endereço
                </div>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group
                  id="lote-group"
                  label="Número/Lote"
                  label-for="lote">
                <input
                    id="lote"
                    ref="ted_numero"
                    v-model="endereco.ted_numero"
                    type="text"
                    maxlength="10"
                    class="form-control"
                    placeholder=" "
                    :class="{'is-invalid': submitted && $v.endereco.ted_numero.$error,}">
                <div v-show="$v.endereco.ted_numero.$error" class="invalid-feedback">
                  Seu Número
                </div>
              </b-form-group>
            </div>
            <div class="col-md-5">
              <b-form-group
                  id="bairro-group"
                  label="Bairro"
                  label-for="cep-reply">
                <input
                    id="bairro"
                    v-model="endereco.ted_bairro"
                    type="text"
                    maxlength="100"
                    class="form-control"
                    placeholder=" "
                    :class="{'is-invalid': submitted && $v.endereco.ted_bairro.$error,}">
                <div v-show="$v.endereco.ted_bairro.$error" class="invalid-feedback">
                  Informe o bairro
                </div>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <b-form-group
                  id="complemento-group"
                  label="Complemento"
                  label-for="complemento">
                <input
                    id="complemento"
                    v-model="endereco.ted_complemento"
                    type="text"
                    maxlength="100"
                    class="form-control"
                    placeholder=" ">
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group
                  id="group-ted_ponto_referencia"
                  label="Ponto de Referência"
                  label-for="ted_ponto_referencia">
                <input
                    id="ted_ponto_referencia"
                    v-model="endereco.ted_ponto_referencia"
                    type="text"
                    maxlength="100"
                    class="form-control"
                    placeholder=" ">
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group
                  id="group-aplicarEnd"
                  label="'"
                  class="text-white"
                  label-for="invalidCheck">
                <div class="form-group">
                  <div class="custom-control custom-checkbox mt-2">
                    <input id="invalidCheck" type="checkbox" v-model="repetirEnd" class="custom-control-input">
                    <label for="invalidCheck" class="custom-control-label text-dark">Repedir o endereço para todos os
                      tipos.</label>
                  </div>
                </div>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-8 text-left">
              <b-form-group label="'" class="text-white" label-for="tfo_numero">
                <h6 v-show="pessoa.tps_tipo === '1' || pessoa.tps_tipo === 1" class="text-dark font-weight-bold">
                  Obrigatório ter endereço comercial no município.</h6>
              </b-form-group>
            </div>
            <div class="col-md-4 text-right">
              <b-form-group label="'" class="text-white" label-for="tfo_numero">
                <button type="button" v-bind:disabled="list_endereco.length > 2" @click="addEndereco"
                        class="btn btn-dark"><i class="bx bx-plus"></i> Incluir endereço
                </button>
              </b-form-group>
            </div>
          </div>
        </b-form>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="table-responsive">
          <h6 v-show="list_endereco.length < 1" class="text-danger mt-3">Necessário informar pelo menos um endereço</h6>
          <table v-show="list_endereco.length > 0" class="table mb-0">
            <thead>
            <tr>
              <th>Tipo</th>
              <th>Endereço/Quadra, núm.</th>
              <th>Bairro</th>
              <th>Cidade - UF</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(e, index) in list_endereco" v-bind:key="e.ted_tipo.ted_codigo">
              <td>{{ e.ted_tipo.tab_nome }}</td>
              <td>{{ e.ted_logradouro }}, {{ e.ted_numero }}</td>
              <td>{{ e.ted_bairro }}</td>
              <td>{{ e.mun_nome }} - {{ e.mun_uf }}</td>
              <td class="text-right">
                <button type="button" @click="removeEndereco(index)" class="btn btn-outline-danger btn-sm"><i
                    class="bx bxs-trash"></i>Remover
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </Loader>
</template>
<script>
import {required} from "vuelidate/lib/validators";
import Loader from "@/components/widgets/loader"
import {getCEP} from "@/api/externa/cep"

export default {
  components: {
    Loader
  },
  props: {
    pessoa: {
      type: Object,
    },
    endereco_tipo: {
      type: Array,
      default: function () {
        return [];
      },
    },
    list_endereco: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      endereco: this.enderecoReset(),
      repetirEnd: true,
      tipoEndExiste: false,
      errorCep: false,
      submitted: false,
      httpSend: false,
    };
  },
  validations: {
    endereco: {
      ted_tipo: {
        required
      },
      ted_cep: {
        required
      },
      ted_bairro: {
        required,
      },
      ted_numero: {
        required,
      },
      ted_logradouro: {
        required,
      },
    }
  },
  methods: {
    enderecoReset() {
      return {
        ted_codigo: null,
        ted_tipo: "",
        ted_cep: "",
        ted_logradouro: "",
        ted_bairro: "",
        ted_numero: "",
        ted_complemento: "",
        ted_ponto_referencia: "",
        mun_codigo: null,
        tps_codigo: null,
        mun_uf: "",
        mun_nome: "",
      }
    },
    locCEP(cep) {
      if (!cep) {
        return
      }
      this.httpSend = true;
      this.errorCep = false;
      getCEP(cep).then(result => {
        if (result.status === 200) {
          if (Object.prototype.hasOwnProperty.call(result.data, 'erro')) {
            this.$refs.ted_cep.focus();
            this.errorCep = true;
            this.endereco.mun_uf = '';
            this.endereco.mun_nome = '';
            this.endereco.mun_codigo = null;
            this.endereco.ted_bairro = '';
            this.endereco.ted_logradouro = '';
          } else {
            this.errorCep = false;
            this.endereco.mun_uf = result.data.uf;
            this.endereco.mun_nome = result.data.localidade;
            this.endereco.mun_codigo = result.data.ibge;
            this.endereco.ted_bairro = result.data.bairro;
            this.endereco.ted_logradouro = result.data.logradouro;
            if (this.endereco.ted_logradouro) {
              this.$refs.ted_numero.focus();
            } else {
              this.$refs.ted_logradouro.focus()
            }
          }
        }
      }).catch(error => {
        this.errorCep = true;
        this.endereco.mun_uf = '';
        this.endereco.mun_nome = '';
        this.endereco.mun_codigo = null;
        console.log(error)
      }).finally(() => {
        this.httpSend = false
      })
    },
    addEndereco() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      if (!this.endereco.mun_codigo) {
        this.$toast.error("Verifique se o CEP foi digitado corretamente. Não utilize o autocompletar do navegador")
        return;
      }
      this.tipoEndExiste = false;
      if (this.exiteTipo(this.endereco.ted_tipo.tab_codigo)) {
        this.tipoEndExiste = true;
        return
      }
      if (this.repetirEnd) {
        this.endereco_tipo.forEach((value) => {
          const end = JSON.parse(JSON.stringify(this.endereco))
          if (this.exiteTipo(value.tab_codigo)) {
            return
          }
          end.ted_tipo = value
          this.list_endereco.push(end);
        });
      } else {
        this.list_endereco.push(this.endereco);
      }
      this.$v.$reset()
      this.endereco = this.enderecoReset();
    },
    removeEndereco(index) {
      this.list_endereco.splice(index, 1);
    },
    exiteTipo(tab_codigo) {
      return this.list_endereco.filter(e => e.ted_tipo.tab_codigo.toString().indexOf(tab_codigo.toString()) > -1).length > 0;
    }
  }
};
</script>

